import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Stack } from '@mui/material';
import Style from 'pages/project-onboarding/style';

const MemberAccessTable = (props) => {
    const { member, index, members } = props;

    const getMemberAction = (action) => {
        switch (action) {
            case true:
                return <Box sx={{ color: (theme) => theme.palette.blue.main, font: (theme) => theme.typography.fontSize.$font_small_medium }}>New</Box>;
            case false:
                return null;
            case 'modify':
                return <Box sx={{ color: (theme) => theme.palette.orange.main, font: (theme) => theme.typography.fontSize.$font_small_medium }}>Modify</Box>;
            default:
                return null;
        }
    };

    const resoureDisplay = (title, action) => {
        return (
            <Box sx={Style?.preview?.memberAccess?.subWrapper} key={title}>
                <Box sx={Style?.preview?.memberAccess?.label}>{title}</Box>
                <Box sx={Style?.preview?.memberAccess?.colon}>:</Box>
                <Box sx={Style?.preview?.memberAccess?.value}>{getMemberAction(action)}</Box>
            </Box>
        );
    };

    const getLabelForSCA = (user) => {
        if (user?.sca && user?.role) {
            return user?.role && `SCA (${user?.role || ''})`;
        }
        if (user?.sca && !user?.role && members?.sca?.length > 0) {
            const scaUser = members?.sca?.find((sca) => sca?.gpid === user?.gpid);
            return `SCA (${scaUser?.role || ''})`;
        }
        return 'SCA';
    };

    return (
        <Grid container sx={Style?.preview?.memberAccess?.container} key={`ma-${index}`}>
            <Grid item xs={7} sm={7}>
                <Stack direction="column" spacing={1}>
                    <Box sx={Style?.preview?.memberAccess?.subWrapper}>
                        <Box sx={Style?.preview?.memberAccess?.label}>GPID</Box>
                        <Box sx={Style?.preview?.memberAccess?.colon}>:</Box>
                        <Box sx={Style?.preview?.memberAccess?.value}>{member?.gpid}</Box>
                    </Box>
                    <Box sx={Style?.preview?.memberAccess?.subWrapper}>
                        <Box sx={Style?.preview?.memberAccess?.label}>Member Name</Box>
                        <Box sx={Style?.preview?.memberAccess?.colon}>:</Box>
                        <Box sx={Style?.preview?.memberAccess?.value}>{member?.name}</Box>
                    </Box>
                    <Box sx={Style?.preview?.memberAccess?.subWrapper}>
                        <Box sx={Style?.preview?.memberAccess?.label}>Email ID</Box>
                        <Box sx={Style?.preview?.memberAccess?.colon}>:</Box>
                        <Box sx={Style?.preview?.memberAccess?.value}>{member?.email !== null ? member?.email : '-'}</Box>
                    </Box>
                </Stack>
            </Grid>
            <Grid item xs={7} sm={5}>
                <Stack direction="column" spacing={1}>
                    {resoureDisplay('Project Admin', member?.projectAdmin)}
                    {resoureDisplay('SonarQube', member?.sonarQube)}
                    {resoureDisplay('Artifactory', member?.artifactory)}
                    {resoureDisplay('SAST', member?.fs)}
                    {resoureDisplay(getLabelForSCA(member), member?.sca)}
                    {resoureDisplay('Test Plan', member?.testPlan)}
                </Stack>
            </Grid>
        </Grid>
    );
};

MemberAccessTable.propTypes = {
    member: PropTypes.object,
    index: PropTypes.number,
    members: PropTypes.object,
};

MemberAccessTable.defaultProps = {
    member: {},
    index: 0,
    members: {},
};

export default MemberAccessTable;
